export default __webpack_public_path__ + "static/media/PowellCatLocation-1.5aa7c4a6.jpg";